export type CustomNumberColumn = {
  id: string;
  name: string;
};

export const CUSTOM_NUMBER_COLUMN_PREFIX = "custom_number:";

const CUSTOM_NUMBER_ID_RE = /^[a-zA-Z0-9_-]{4,64}$/;

export function customNumberColumnKey(id: string): string {
  return `${CUSTOM_NUMBER_COLUMN_PREFIX}${id}`;
}

export function parseCustomNumberColumnKey(key: string): string | null {
  if (!key.startsWith(CUSTOM_NUMBER_COLUMN_PREFIX)) return null;
  const id = key.slice(CUSTOM_NUMBER_COLUMN_PREFIX.length);
  return CUSTOM_NUMBER_ID_RE.test(id) ? id : null;
}

export function isCustomNumberColumnKey(key: string): boolean {
  return parseCustomNumberColumnKey(key) !== null;
}

export function customNumberValueKey(columnId: string, rowKey: string): string {
  return `${columnId}\u0001${rowKey}`;
}

export function makeCustomNumberColumnId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID().replace(/-/g, "").slice(0, 16);
  }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
}

export function sanitizeCustomNumberColumns(value: unknown): CustomNumberColumn[] {
  if (!Array.isArray(value)) return [];
  const out: CustomNumberColumn[] = [];
  const seen = new Set<string>();
  for (const raw of value) {
    if (!raw || typeof raw !== "object") continue;
    const item = raw as Record<string, unknown>;
    const id = typeof item.id === "string" ? item.id.trim() : "";
    if (!CUSTOM_NUMBER_ID_RE.test(id) || seen.has(id)) continue;
    const name = typeof item.name === "string" ? item.name.trim().slice(0, 60) : "";
    if (!name) continue;
    seen.add(id);
    out.push({ id, name });
    if (out.length >= 50) break;
  }
  return out;
}

export function customNumberColumnLabel(columns: CustomNumberColumn[] | undefined, key: string): string | null {
  const id = parseCustomNumberColumnKey(key);
  if (!id) return null;
  return columns?.find(column => column.id === id)?.name ?? null;
}
